import { render, staticRenderFns } from "./CustomerDetail-contacts.vue?vue&type=template&id=1a03ba02&scoped=true"
import script from "./CustomerDetail-contacts.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-contacts.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail-contacts.vue?vue&type=style&index=0&id=1a03ba02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a03ba02",
  null
  
)

export default component.exports